import { useTheme, useMediaQuery } from '@mui/material'

/** https://github.com/mui/material-ui/issues/23885 */
export const useBreakpoint = () => {
    const theme = useTheme()

    const xsBreakpoint = useMediaQuery(theme.breakpoints.only('xs'))
    const smBreakpoint = useMediaQuery(theme.breakpoints.only('sm'))
    const mdBreakpoint = useMediaQuery(theme.breakpoints.only('md'))
    const lgBreakpoint = useMediaQuery(theme.breakpoints.only('lg'))
    const xlBreakpoint = useMediaQuery(theme.breakpoints.only('xl'))

    switch (true) {
        case xsBreakpoint:
            return 'xs'
        case smBreakpoint:
            return 'sm'
        case mdBreakpoint:
            return 'md'
        case lgBreakpoint:
            return 'lg'
        case xlBreakpoint:
            return 'xl'
        default:
    }

    return undefined
}

export const useIsMobile = () => {
    const mobile = useMediaQuery('(max-width: 600px)')
    return mobile
}

export const useIsDesktop = () => {
    const desktop = useMediaQuery('(min-width: 600px)')
    return desktop
}

export const useIsLandscape = () => {
    const landscape = useMediaQuery('(orientation: landscape) and (max-width: 700px)')
    return landscape
}

export const useIsMdDownScreen = () => {
    const theme = useTheme()
    const medium = useMediaQuery(theme.breakpoints.down('md'))

    return medium
}
